import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CorporateClientDetails from "../components/CorporateClientDetails";

const CorporateClientDetailsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Client Details' />

        {/* BlankPageLayer */}
        <CorporateClientDetails />
      </MasterLayout>
    </>
  );
};

export default CorporateClientDetailsPage;

